/* OPEN POP UI: AJAX cart + drawer, variant pills, tabs, steppers. No dependencies.
   In the static preview, window.OpenPop.mock supplies a local cart instead of /cart/*.js. */
(function () {
  'use strict';
  var OP = window.OpenPop || (window.OpenPop = {});
  var S = OP.strings || {};
  var routes = OP.routes || { cartAdd: '/cart/add', cartChange: '/cart/change', cart: '/cart' };

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || OP.moneyFormat || '{{amount}}';
    function delimit(n, precision, thousands, decimal) {
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return delimit(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return delimit(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delimit(cents, 0, '.', ',');
        default: return delimit(cents, 2, ',', '.');
      }
    });
  }
  OP.formatMoney = formatMoney;

  /* ---------- cart API (Shopify or local mock) ---------- */
  function json(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || S.cartError || 'Cart error');
        return data;
      });
    });
  }
  var shopifyApi = {
    get: function () { return json(routes.cart + '.js'); },
    add: function (id, qty) { return json(routes.cartAdd + '.js', { items: [{ id: Number(id), quantity: qty }] }); },
    addMany: function (ids) { return json(routes.cartAdd + '.js', { items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) }); },
    change: function (key, qty) { return json(routes.cartChange + '.js', { id: key, quantity: qty }); }
  };
  function mockApi(mock) {
    var items = [];
    var KEY = 'openpop-preview-cart';
    try { items = JSON.parse(sessionStorage.getItem(KEY) || '[]') || []; } catch (e) { items = []; }
    function save() { try { sessionStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {} }
    function snapshot() {
      save();
      var count = 0, total = 0;
      items.forEach(function (i) { i.final_line_price = i.price * i.quantity; count += i.quantity; total += i.final_line_price; });
      return Promise.resolve(JSON.parse(JSON.stringify({ items: items, item_count: count, total_price: total })));
    }
    return {
      get: snapshot,
      add: function (id, qty) {
        var v = mock.variants[String(id)];
        if (!v) return Promise.reject(new Error(S.cartError || 'Cart error'));
        var found = items.filter(function (i) { return i.key === String(id); })[0];
        if (found) found.quantity += qty;
        else items.push({ key: String(id), id: Number(id), quantity: qty, price: v.price, product_title: v.product_title, variant_title: v.title, image: v.image, url: '#', handle: v.handle });
        return snapshot();
      },
      addMany: function (ids) {
        var self = this, chain = Promise.resolve();
        ids.forEach(function (id) { chain = chain.then(function () { return self.add(id, 1); }); });
        return chain;
      },
      change: function (key, qty) {
        items = items.filter(function (i) { if (i.key === key) i.quantity = qty; return i.quantity > 0; });
        return snapshot();
      }
    };
  }
  var api = OP.mock ? mockApi(OP.mock) : shopifyApi;
  OP.cart = api;

  /* ---------- drawer ---------- */
  var drawer, panel, linesEl, totalEl, footEl, lastFocus;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function flavourOf(item) { return /lemon/i.test((item.handle || '') + ' ' + (item.product_title || '')) ? 'lemon' : 'grape'; }

  function render(cart) {
    if (!drawer) return;
    document.querySelectorAll('[data-op-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    if (!cart.items.length) {
      linesEl.innerHTML = '<div class="op-drawer__empty"><p>' + esc(S.cartEmpty || 'Your cart is empty.') + '</p>' +
        '<a class="op-btn op-btn--ink" href="' + esc(OP.shopUrl || '/collections/all') + '" data-op-cart-close>' + esc(S.shopCans || 'Shop the cans') + '</a></div>';
      footEl.hidden = true;
      return;
    }
    footEl.hidden = false;
    linesEl.innerHTML = cart.items.map(function (item) {
      var key = flavourOf(item);
      var img = item.image || (OP.assets && OP.assets[key === 'lemon' ? 'stillLemon' : 'stillGrape']) || '';
      var deep = key === 'lemon' ? '#5AA345' : '#402E7F';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      return '<div class="op-line" data-key="' + esc(item.key) + '">' +
        '<div class="op-line__img" style="--fl-dk:' + deep + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div><p class="op-line__title">' + esc(item.product_title) + '</p>' +
        (variant ? '<p class="op-line__variant">' + esc(variant) + '</p>' : '') +
        '<div class="op-qty" role="group" aria-label="Quantity"><button type="button" data-op-qty="-1" aria-label="Decrease">&minus;</button><span>' + item.quantity + '</span><button type="button" data-op-qty="1" aria-label="Increase">+</button></div>' +
        '<button type="button" class="op-line__remove" data-op-remove>' + esc(S.remove || 'Remove') + '</button></div>' +
        '<p class="op-line__price">' + esc(formatMoney(item.final_line_price)) + '</p>' +
        '</div>';
    }).join('');
    totalEl.textContent = formatMoney(cart.total_price);
  }

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { drawer.classList.add('is-open'); }); });
    document.documentElement.style.overflow = 'hidden';
    panel.focus();
    api.get().then(render).catch(showError);
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; }, 450);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function showError(err) {
    if (!linesEl) return;
    var p = document.createElement('p');
    p.className = 'op-drawer__error';
    p.textContent = (err && err.message) || S.cartError || 'Cart error';
    linesEl.prepend(p);
  }
  function bump() {
    document.querySelectorAll('[data-op-cart-open]').forEach(function (el) {
      el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
    });
  }

  /* ---------- variant pills ---------- */
  function syncForm(form) {
    var checked = form.querySelector('input[name="id"]:checked');
    if (!checked) return;
    var priceEl = form.querySelector('[data-op-price]');
    var btn = form.querySelector('[data-op-add]');
    if (priceEl && checked.dataset.price) {
      var sample = priceEl.querySelector('.op-sample');
      priceEl.textContent = checked.dataset.price;
      if (sample) priceEl.appendChild(sample);
    }
    var ok = checked.dataset.available !== 'false';
    if (btn) {
      btn.disabled = !ok;
      btn.textContent = ok ? (S.addToCart || 'Add to cart') : (S.soldOut || 'Sold out');
    }
    if (form.id) {
      var sticky = document.querySelector('[data-op-sticky][data-form="' + form.id + '"]');
      if (sticky) {
        var label = checked.closest('label');
        var v = sticky.querySelector('[data-op-sticky-variant]');
        var pr = sticky.querySelector('[data-op-sticky-price]');
        if (v && label) v.textContent = label.textContent.trim();
        if (pr) pr.textContent = checked.dataset.price || '';
        var sb = sticky.querySelector('button');
        if (sb) sb.disabled = !ok;
      }
    }
  }

  function onSubmit(e) {
    var form = e.target.closest('[data-op-add-form]');
    if (!form) return;
    e.preventDefault();
    var idInput = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var btn = form.querySelector('[data-op-add]');
    if (!idInput) return;
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = S.adding || 'Adding'; }
    api.add(idInput.value, Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1))
      .then(function () { return api.get(); })
      .then(function (cart) {
        render(cart); bump();
        if (btn) {
          btn.classList.add('is-added'); btn.textContent = S.added || 'Added';
          setTimeout(function () { btn.classList.remove('is-added'); btn.disabled = false; btn.textContent = label; }, 1600);
        }
        openDrawer();
      })
      .catch(function (err) {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        openDrawer(); setTimeout(function () { showError(err); }, 50);
      });
  }

  /* ---------- tabs (nutrition) ---------- */
  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (d) { e.preventDefault(); select(tabs[(i + d + tabs.length) % tabs.length], true); }
      });
    });
    root.opSelectKey = function (key) {
      var t = tabs.filter(function (x) { return x.dataset.key === key; })[0];
      if (t) select(t);
    };
  }


  /* ---------- card turntables: 24 pre-rendered frames of the real GLB, no WebGL ---------- */
  function initTurns() {
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cards = document.querySelectorAll('[data-op-card]');
    if (!cards.length || reducedMotion) return;
    var load = function (turn) {
      if (turn.dataset.loaded) return;
      turn.dataset.loaded = '1';
      turn.style.backgroundImage = 'url("' + turn.dataset.opTurn + '")';
    };
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var t = en.target.querySelector('[data-op-turn]');
        if (t) { if (window.requestIdleCallback) requestIdleCallback(function () { load(t); }, { timeout: 800 }); else setTimeout(function () { load(t); }, 300); }
      });
    }, { rootMargin: '300px' }) : null;
    cards.forEach(function (card) {
      var turn = card.querySelector('[data-op-turn]');
      if (!turn) return;
      if (io) io.observe(card); else load(turn);
      var n = parseInt(turn.dataset.frames, 10) || 24;
      var frame = 0, want = false, raf = 0, last = 0;
      function step(t) {
        if (t - last > 1400 / n) {
          last = t;
          frame = (frame + 1) % n;
          turn.style.backgroundPosition = (frame / (n - 1)) * 100 + '% 0';
        }
        if (want || frame !== 0) raf = requestAnimationFrame(step);
        else { raf = 0; card.classList.remove('is-turning'); }
      }
      function start() {
        load(turn); want = true;
        card.classList.add('is-turning');
        if (!raf) raf = requestAnimationFrame(step);
      }
      function stop() { want = false; }
      card.addEventListener('pointerenter', function (e) { if (e.pointerType !== 'touch') start(); });
      card.addEventListener('pointerleave', stop);
      card.addEventListener('focusin', start);
      card.addEventListener('focusout', function () { if (!card.contains(document.activeElement)) stop(); });
    });
  }

  /* ---------- sticky add-to-cart ---------- */
  function initSticky() {
    var sticky = document.querySelector('[data-op-sticky]');
    var form = sticky && document.getElementById(sticky.dataset.form);
    if (!sticky || !form || !('IntersectionObserver' in window)) return;
    sticky.hidden = false;
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      var past = !en.isIntersecting && en.boundingClientRect.top < 0;
      sticky.classList.toggle('is-in', past);
      sticky.toggleAttribute('inert', !past);
    }, { rootMargin: '-64px 0px 0px 0px' }).observe(form);
    sticky.toggleAttribute('inert', true);
    // keep out of the way of the pinned 3D benefits (its progress bar lives at the bottom)
    var bnfStage = document.querySelector('.op-bnf__stage');
    if (bnfStage) new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-muted', entries[0].intersectionRatio > 0.5);
    }, { threshold: [0, 0.5, 1] }).observe(bnfStage);
  }

  /* ---------- collection filters ---------- */
  function initFilters() {
    var form = document.querySelector('[data-op-filters]');
    if (!form) return;
    var grid = document.querySelector('[data-op-grid]');
    var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-op-card]')) : [];
    var countEl = document.querySelector('[data-op-count]');
    var none = document.querySelector('[data-op-none]');
    var clear = form.querySelector('[data-op-clear]');
    function packValues() {
      return Array.prototype.slice.call(form.querySelectorAll('input[type="checkbox"]:checked'))
        .filter(function (i) { return /option|pack/i.test(i.name); }).map(function (i) { return i.value; });
    }
    function preselectPacks() {
      var packs = packValues();
      if (!packs.length) return;
      cards.forEach(function (card) {
        var pills = card.querySelectorAll('input[name="id"]');
        for (var i = 0; i < pills.length; i++) {
          var txt = pills[i].closest('label').textContent.trim();
          if (packs.indexOf(txt) > -1) { pills[i].checked = true; syncForm(pills[i].form); break; }
        }
      });
    }
    function applyMock() {
      var groups = {};
      form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (i) { (groups[i.dataset.opFilter] = groups[i.dataset.opFilter] || []).push(i.value.toLowerCase()); });
      var shown = 0;
      cards.forEach(function (card) {
        var ok = Object.keys(groups).every(function (g) {
          var vals = groups[g];
          if (/flavour|flavor|type/i.test(g)) return vals.indexOf(card.dataset.flavour) > -1;
          var packs = card.dataset.packs.toLowerCase().split('|');
          return vals.some(function (v) { return packs.indexOf(v) > -1; });
        });
        card.hidden = !ok;
        if (ok) shown++;
      });
      var sort = form.querySelector('[data-op-sort]').value;
      var sorted = cards.slice().sort(function (a, b) {
        if (sort === 'price-ascending') return a.dataset.price - b.dataset.price;
        if (sort === 'price-descending') return b.dataset.price - a.dataset.price;
        if (sort === 'title-ascending') return a.dataset.title.localeCompare(b.dataset.title);
        if (sort === 'title-descending') return b.dataset.title.localeCompare(a.dataset.title);
        return cards.indexOf(a) - cards.indexOf(b);
      });
      sorted.forEach(function (c) { grid.appendChild(c); });
      if (countEl) countEl.textContent = shown + (shown === 1 ? ' soda' : ' sodas');
      if (none) none.hidden = shown > 0;
      if (clear) clear.hidden = !Object.keys(groups).length;
    }
    form.addEventListener('change', function (e) {
      if (OP.mock) { applyMock(); preselectPacks(); return; }
      var params = new URLSearchParams(new FormData(form));
      window.location.search = params.toString();
    });
    if (clear && OP.mock) clear.addEventListener('click', function (e) {
      e.preventDefault();
      form.querySelectorAll('input[type="checkbox"]').forEach(function (i) { i.checked = false; });
      applyMock();
    });
    form.addEventListener('submit', function (e) { if (OP.mock) e.preventDefault(); });
    preselectPacks();
  }

  /* ---------- boot ---------- */
  function init() {
    drawer = document.querySelector('[data-op-drawer]');
    if (drawer) {
      panel = drawer.querySelector('.op-drawer__panel');
      linesEl = drawer.querySelector('[data-op-cart-lines]');
      totalEl = drawer.querySelector('[data-op-cart-total]');
      footEl = drawer.querySelector('[data-op-cart-foot]');
      drawer.addEventListener('click', function (e) {
        if (e.target.closest('[data-op-cart-close]')) {
          var a = e.target.closest('a[data-op-cart-close]');
          if (!a || a.getAttribute('href').charAt(0) === '#') e.preventDefault();
          closeDrawer();
          if (a && OP.mock) { e.preventDefault(); var t = document.querySelector('#op-shop'); if (t) t.scrollIntoView({ behavior: 'smooth' }); }
          return;
        }
        var line = e.target.closest('.op-line');
        if (!line) return;
        var key = line.dataset.key;
        var qtyBtn = e.target.closest('[data-op-qty]');
        var q = parseInt(line.querySelector('.op-qty span').textContent, 10);
        if (qtyBtn) api.change(key, Math.max(0, q + parseInt(qtyBtn.dataset.opQty, 10))).then(render).catch(showError);
        if (e.target.closest('[data-op-remove]')) api.change(key, 0).then(render).catch(showError);
      });
      drawer.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeDrawer();
        if (e.key === 'Tab') {
          var f = panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex="0"]');
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });
      var checkout = drawer.querySelector('[data-op-checkout]');
      if (checkout && OP.mock) checkout.addEventListener('submit', function (e) {
        e.preventDefault();
        var b = checkout.querySelector('button');
        b.textContent = OP.mock.checkoutNote || 'Checkout opens on the live store';
      });
    }
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-op-cart-open]');
      if (opener && drawer) { e.preventDefault(); openDrawer(); }
      var menuLink = e.target.closest('.op-nav__link');
      if (menuLink) { var d = menuLink.closest('details'); if (d) d.open = false; }
    });
    document.addEventListener('submit', onSubmit);
    document.addEventListener('change', function (e) {
      var form = e.target.closest('[data-op-add-form]');
      if (form && e.target.name === 'id') syncForm(form);
    });
    document.querySelectorAll('[data-op-add-form]').forEach(syncForm);
    document.querySelectorAll('[data-op-tabs]').forEach(initTabs);
    initTurns();
    initSticky();
    initFilters();
    document.addEventListener('click', function (e) {
      var many = e.target.closest('[data-op-add-many]');
      if (!many) return;
      var label = many.textContent;
      many.disabled = true; many.textContent = S.adding || 'Adding';
      api.addMany(many.dataset.opAddMany.split(','))
        .then(function () { return api.get(); })
        .then(function (cart) { render(cart); bump(); many.disabled = false; many.textContent = label; openDrawer(); })
        .catch(function (err) { many.disabled = false; many.textContent = label; openDrawer(); setTimeout(function () { showError(err); }, 50); });
    });
    if (OP.mock) api.get().then(function (cart) { document.querySelectorAll('[data-op-cart-count]').forEach(function (el) { el.textContent = cart.item_count; }); });
    document.querySelectorAll('[data-op-stepper]').forEach(function (st) {
      var input = st.querySelector('input');
      var out = st.querySelector('span');
      st.addEventListener('click', function (e) {
        var b = e.target.closest('[data-op-step]');
        if (!b) return;
        var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.opStep, 10));
        input.value = v; if (out) out.textContent = v;
      });
    });
    if (OP.mock) document.querySelectorAll('form:not([data-op-add-form])').forEach(function (f) {
      f.addEventListener('submit', function (e) { e.preventDefault(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
